import { tracking } from '@automata/utils';
import { Dict } from 'mixpanel-browser';
import { MouseEvent, useCallback } from 'react';

import { Button, ButtonProps } from '../Button';

interface ExtendedTrackingProps {
  /**
   * [screen or dashboard].[optional category].[action]
   * e.g. deviceDashboard.control.start
   */
  trackLabel: string;
  /**
   * If Group or Device specific, use ID
   */
  trackProps?: Dict;
  onClick?: ButtonProps['onClick'];
  loading?: boolean;
}

export type TrackingButtonProps = ButtonProps & ExtendedTrackingProps;

export const TrackedButton = ({
  children,
  trackLabel,
  trackProps,
  onClick,
  loading,
  ...buttonProps
}: TrackingButtonProps): JSX.Element => {
  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      onClick?.(e);
      tracking.track(trackLabel, trackProps);
    },
    [onClick, trackLabel, trackProps]
  );

  return (
    <Button
      data-cy={trackLabel}
      onClick={handleClick}
      loading={loading}
      {...buttonProps}
    >
      {children}
    </Button>
  );
};

TrackedButton.displayName = 'TrackedButton';
